(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Lookbook"] && !Shopify.designMode) return;
  try {
    
const swiper = new Swiper('.product-carousel', {
  slidesPerView: 2,
  slidesPerGroup: 2,
  spaceBetween: 20,
  loop: true,

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },

  breakpoints: {
    0: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 10
    },
    768: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 20
    }
  },

  on: {
    slideChangeTransitionEnd: function() {
      const totalImages = document.querySelectorAll('.model-image');
      if (totalImages.length === 0) return;

      // Hide all images first
      totalImages.forEach(img => img.classList.add('hidden'));

      // Show next image in order based on active index
      const currentIndex = this.realIndex % totalImages.length;
      totalImages[currentIndex].classList.remove('hidden');
    },

    init: function() {
      this.emit('slideChangeTransitionEnd');
    }
  }
});

  } catch(e) { console.error(e); }
})();
})();
